import { twMerge } from "tailwind-merge";

import {
  DIRECT_INQUIRY,
  INDIRECT_INQUIRY,
} from "../constants/patientIntakePreview";
import {
  DirectInquiryType,
  IndirectInquiryType,
} from "./types/patientIntakePreview";

export const getPreviewDirectInquiryColor = (
  directInquiry: DirectInquiryType,
) => {
  const inquiryColor = {
    [DIRECT_INQUIRY.positive]: "text-complementary-success-800",
    [DIRECT_INQUIRY.mixed]: "text-complementary-warning-600",
    [DIRECT_INQUIRY.negative]: "text-complementary-error-700",
    [DIRECT_INQUIRY.na]: "text-black",
  };

  return inquiryColor[directInquiry];
};

export const getPreviewIndirectInquiryColor = (
  indirectInquiry: IndirectInquiryType,
) => {
  const inquiryColor = {
    [INDIRECT_INQUIRY.positive]: "text-complementary-success-800",
    [INDIRECT_INQUIRY.partially_positive]: "text-complementary-success-800",
    [INDIRECT_INQUIRY.mixed]: "text-complementary-warning-600",
    [INDIRECT_INQUIRY.neutral]: "text-gray-10",
    [INDIRECT_INQUIRY.partially_negative]: "text-complementary-error-700",
    [INDIRECT_INQUIRY.negative]: "text-complementary-error-700",
    [INDIRECT_INQUIRY.na]: "text-black",
  };

  return inquiryColor[indirectInquiry];
};

export const getPreviewInquiryIconColor = (
  directInquiry: DirectInquiryType,
  indirectInquiry: IndirectInquiryType,
  withFill?: boolean,
) => {
  const inquiryColor = {
    [DIRECT_INQUIRY.positive]: {
      [INDIRECT_INQUIRY.positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.partially_positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.mixed]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.neutral]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.partially_negative]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.negative]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.na]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
    },
    [DIRECT_INQUIRY.mixed]: {
      [INDIRECT_INQUIRY.positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.partially_positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.mixed]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.neutral]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.partially_negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.na]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
    },
    [DIRECT_INQUIRY.negative]: {
      [INDIRECT_INQUIRY.positive]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.partially_positive]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.mixed]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.neutral]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.partially_negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.na]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
    },
    [DIRECT_INQUIRY.na]: {
      [INDIRECT_INQUIRY.positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.partially_positive]: twMerge(
        "text-complementary-success-300 stroke-complementary-success-800",
        withFill && "fill-complementary-success-800",
      ),
      [INDIRECT_INQUIRY.mixed]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.neutral]: twMerge(
        "text-orange-20 stroke-orange-70",
        withFill && "fill-orange-70",
      ),
      [INDIRECT_INQUIRY.partially_negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.negative]: twMerge(
        "text-complementary-error-100 stroke-error",
        withFill && "fill-error",
      ),
      [INDIRECT_INQUIRY.na]: twMerge(
        "text-neutral-5 stroke-gray-90",
        withFill && "fill-neutral-5",
      ),
    },
  };

  return inquiryColor[directInquiry][indirectInquiry];
};
